import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { Link } from 'react-router-dom'
import PageTitle from '../PageTitle'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  InputLabel,
  Paper,
  Typography
} from '@material-ui/core'
import { FormLoader } from '../Loader/FormLoader'
import { InvoiceViewConsumer } from '../../context/InvoiceViewContext'
import { useStyles } from '../Invoice/Steps/Styles'
import { singleInvoiceStyles } from './Styles'
import SingleInvoiceActions from './SingleInvoiceActions'
import { NamedRoutes } from '../../routes'
import { formatRoute } from 'react-router-named-routes'
import { calculateDecimal, concatBranchAddress, filterData, getStatusIcon } from '../../utils/helpers'
import invoicesStatus from '../../configurations/invoices-status'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import EventIcon from '@material-ui/icons/Event'
import ScheduleIcon from '@material-ui/icons/Schedule'
import CancelIcon from '@material-ui/icons/Cancel'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PostAddSharpIcon from '@material-ui/icons/PostAddSharp'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined'
import LocalShippingSharpIcon from '@material-ui/icons/LocalShippingSharp'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import FingerprintIcon from '@material-ui/icons/Fingerprint'
import 'moment/locale/ar-sa'
import Moment from 'react-moment'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import ItemsList from '../Invoice/Steps/Step3/ItemsList'
import { formStyles } from '../Invoice/Steps/FormStyles'
import receiverTypes from '../../configurations/receiver-types'
import taxTypes from '../../configurations/tax-types'
import nonTaxableTaxTypes from '../../configurations/non-taxable-tax-types'
import { AuthConsumer } from '../../context/AuthContext'
import { ListingTableConsumer, ListingTableProvider } from '../../context/ListingTableContext'

const SingleInvoicePageContent = ({ locale, isMs = false }) => {
  // to check if  the invoice is ms or sp 
  let submissionRoute = isMs ? NamedRoutes.msSubmission : NamedRoutes.submission
  const classes = useStyles()
  const formClasses = formStyles()
  const invoiceClasses = singleInvoiceStyles()
  const getColumnValue = (key, value, isReceiverType) => {
    if (!!key) {
      switch (key) {
        case 'dateTimeIssued':
        case 'dateTimeRecevied':
        case 'cancelRequestDate':
        case 'cancelRequestDelayedDate':
        case 'declineCancelRequestDate':
        case 'rejectRequestDate':
        case 'rejectRequestDelayedDate':
        case 'declineRejectRequestDate':
          return <div className={invoiceClasses.dateContainer}>
            <div className={'date'}>
              <strong><EventIcon/><Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                          format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
              <strong><ScheduleIcon/><Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                             format="hh:mm A">{value}</Moment></strong>
              <span><FormattedMessage id={'Cairo'}/></span>
            </div>
            <div className={'utc'}>
              ( <Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                        format={locale === 'ar' ? 'YYYY/MM/DD ، hh:mm A ' : 'DD/MM/YYYY hh:mm A'} utc>{value}</Moment>
              <span><FormattedMessage id={'UTC'}/></span> )
            </div>
          </div>
        case 'serviceDeliveryDate':
          return <div className={invoiceClasses.dateContainer}>
            <div className={'date'}>
              <strong><EventIcon/><Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                          format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
            </div>
          </div>
        case 'addressObj':
          return concatBranchAddress(value)

        case 'type':
          let type = !!isReceiverType ? receiverTypes[value] : {}
          return (!!type && !!Object.keys(type).length) ? type[`name_${locale}`] : value

        case 'taxTotals':
          let sum = 0
          if (!!value?.length) {
            value?.forEach(tax => {
              sum += parseInt(tax?.amount || 0)
            })
          }
          return calculateDecimal(sum)

        case 'references':
          return !!value?.length && value?.map((item, index) => <div key={index}><strong>{item}</strong></div>)

        case 'dateValidity':
          return <Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                         format="DD-MM-yyyy hh:mm A">{value}</Moment>

        case 'grossWeight':
        case 'netWeight':
          return <>{value} <FormattedMessage id='kg'/></>
        case 'signatures':
          return <>{!!value?.length && value?.map((signature, index) =>
            <Alert severity="success" key={index} className={formClasses.FormRow}>
              <AlertTitle><FormattedMessage id='signedBy'/>:</AlertTitle>
              <strong>{signature.signedBy}</strong>
            </Alert>
          )}</>
        default:
          return <strong>{value}</strong>
      }
    } else {
      return ''
    }
  }
  const getGroupIcon = (group) => {
    switch (group) {
      case 'issuer':
        return <ArrowUpwardOutlinedIcon color={'primary'}/>
      case 'receiver':
        return <ArrowDownwardOutlinedIcon color={'secondary'}/>
      case 'invoiceItems':
        return <PostAddSharpIcon/>
      case 'order':
        return <TrendingUpIcon/>
      case 'payment':
        return <AccountBalanceIcon/>
      case 'delivery':
        return <LocalShippingSharpIcon/>
      case 'signatures':
        return <FingerprintIcon/>
      default:
        return ''
    }
  }
  return (
    <InvoiceViewConsumer>
      {({ id, invoiceData, invoiceDataLoading, isUserSubmitter }) => {
        let transformedState = (invoiceData?.status?.status === 'Valid' && !!invoiceData?.status?.cancelRequestDate && !!invoiceData?.status?.cancelRequestDelayedDate)
          ? invoicesStatus?.filter(item => item.key.toString().toLowerCase() === 'cancelled')
          : (invoiceData?.status?.status === 'Valid' && !!invoiceData?.status?.rejectRequestDate && !!invoiceData?.status?.rejectRequestDelayedDate)
            ? invoicesStatus?.filter(item => item.key.toString().toLowerCase() === 'rejected') : null
        return (
          <>
            <PageTitle
              title={<FormattedMessage id='SingleInvoicePageContent.PageTitle' values={{
                uuid: id,
                span: chunk => <span>{chunk}</span>
              }}/>}
              invoice
              singleInvoice
            />
            {!!invoiceDataLoading && <FormLoader loading={true}/>}
            <Paper elevation={0} className={invoiceClasses.invoiceGeneralDataWrapper}>
              {!!Object.keys(invoiceData).length && <>
                <div className={invoiceClasses.invoiceTitleActionWrapper}>
                  <Typography variant={'h5'} component={'h2'}>{ !!isUserSubmitter ?
                    <ArrowUpwardOutlinedIcon color={'primary'}/> :
                    <ArrowDownwardOutlinedIcon color={'secondary'}/>} {invoiceData?.general?.documentTypeName}&nbsp;
                    {!!invoiceData?.general?.documentTypeVersion && <FormattedMessage
                      id={`documentTypeVersion.single.${invoiceData?.general?.documentTypeVersion}`}/>}
                  </Typography>
                  <div className={invoiceClasses.invoiceActions}>
                    <AuthConsumer>
                      {({ userPermissions }) => (
                        <SingleInvoiceActions id={id} isSubmitted={isUserSubmitter} userPermissions={userPermissions}
                                              msId={invoiceData?.printableData?.MSuuid?.toString()}
                                              isMs={isMs}
                                              invoiceData={invoiceData}
                                              documentType={invoiceData?.general?.documentType}
                                              status={invoiceData?.status}/>
                      )}
                    </AuthConsumer>
                  </div>
                </div>
                {!!isUserSubmitter && <div className={invoiceClasses.submissionLinkWrapper}>
                  <Typography paragraph>
                    <FormattedMessage id={'goTo.submissionLink.text'}/>
                    <Button size={'medium'} variant={'text'} color={'primary'} component={Link}
                            to={formatRoute(submissionRoute, { id: invoiceData?.general?.submissionUUID })}
                            className={invoiceClasses.submissionLink} disableRipple disableElevation>
                      {invoiceData?.general?.submissionUUID}
                    </Button>
                  </Typography>
                </div>}
                <div className={invoiceClasses.invoiceStatusWrapper}>
                  <div className={invoiceClasses.invoiceStatusValueWrapper}>
                    {!!invoiceData?.status?.MSStatus && <div
                      className={invoiceClasses.invoiceStatusContainer + ` ${invoiceData?.status?.MSStatus?.toString()?.toLowerCase()}`}>
                      {getStatusIcon(invoiceData?.status?.MSStatus, true)}
                      <span>{invoiceData?.status?.msStatusName}</span>
                    </div>}
                    {/*{!!invoiceData?.status?.status && <div*/}
                    {/*  className={invoiceClasses.invoiceStatusContainer + `${!!isMs ? ` ${invoiceData?.status?.status?.toString()?.toLowerCase()}` : !invoiceData?.status?.MSStatus ? ' spStatus' : ''}`}>*/}
                    {/*  <span>{invoiceData?.status?.statusName}</span>*/}
                    {/*</div>}*/}
                    {!!invoiceData?.status?.status && (!!isMs ? <div
                        className={invoiceClasses.invoiceStatusContainer + ` ${invoiceData?.status?.status?.toString()?.toLowerCase()}`}>
                        {getStatusIcon(invoiceData?.status?.status, true)}
                        <span>{invoiceData?.status?.statusName}</span>
                      </div>
                      : <div
                        className={invoiceClasses.invoiceStatusContainer + `${!invoiceData?.status?.MSStatus ? ' spStatus' : ''}`}>
                        <span>{invoiceData?.status?.statusName}</span>
                      </div>)}

                    {!!transformedState && !!transformedState.length && <>
                      <ArrowForwardIcon className={invoiceClasses.invoiceStatusTransition}/>
                      <div
                        className={invoiceClasses.invoiceStatusContainer + ` ${transformedState[0]['key']?.toString()?.toLowerCase()}`}>
                        {getStatusIcon(transformedState[0]['key'], true)}
                        <strong>{transformedState[0][`name_${locale}`]}</strong>
                      </div>
                    </>
                    }
                  </div>
                  {!!invoiceData?.status?.documentStatusReason &&
                  ((!!transformedState && !!transformedState.length) || ['cancelled', 'rejected'].includes(invoiceData?.status?.status?.toString()?.toLowerCase())) &&
                  <div className={invoiceClasses.invoiceStatusReason}>
                    <InputLabel><FormattedMessage
                      id={`Fields.label.reason.${(!!transformedState?.length ? transformedState[0]['key'] : invoiceData?.status?.status)?.toString()?.toLowerCase()}`}/>:</InputLabel>
                    <strong className={'info-data'}>
                      {invoiceData?.status?.documentStatusReason}
                    </strong>
                  </div>
                  }
                </div>
                {!!invoiceData?.freeze &&
                <Alert className={invoiceClasses.invoiceValidations} severity="warning">
                  <div className={classes.frozenMessage}>
                    <FormattedMessage id='invoices.action.frozenMessage' values={{
                      strong: chunks => <strong>{chunks}</strong>,
                      date: <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                    format={locale === 'ar' ? 'YYYY/MM/DD hh:mm A' : 'DD/MM/YYYY hh:mm A'}>{invoiceData?.freeze?.actionDate}</Moment>
                    }}/>
                  </div>
                  <FormattedMessage id='invoices.action.frozenActions'/>
                </Alert>}

                <div className={invoiceClasses.invoiceDatesWrapper}>
                  {Object.keys(invoiceData?.printableData || {})?.map((column, index) => (
                    !!invoiceData?.printableData[column] &&
                    <div className={invoiceClasses.printableDataItem} key={index}>
                      <InputLabel><FormattedMessage
                        id={`Fields.view.label.${!!isMs && 'uuid' === column ? 'MS' : ''}${column}`}/>:</InputLabel>
                      <div className={'info-data'}>
                        {getColumnValue(column, invoiceData?.printableData[column])}
                      </div>
                    </div>
                  ))}
                </div>
                {!!invoiceData?.validation?.length &&
                <Alert className={invoiceClasses.invoiceValidations} icon={<CancelIcon/>} severity="error">
                  <AlertTitle><FormattedMessage id={'invoice.validation.title'}/>:</AlertTitle>
                  <ul>
                    {invoiceData?.validation?.map((validation, index) => (
                      <li key={index}>
                        <AlertTitle>{validation?.title} {!!validation?.subTitle && <>({validation?.subTitle})</>}</AlertTitle>
                        {!!validation?.list?.length && <ul>
                          {validation?.list?.map((validationItem, innerIndex) => (
                            <li key={`${index}-${innerIndex}`}>
                              <strong>{validationItem?.code}</strong> {validationItem?.name}
                            </li>
                          ))}
                        </ul>}
                      </li>
                    ))}
                  </ul>
                </Alert>
                }
              </>}
            </Paper>
            <Paper elevation={4} className={classes.invoiceStepWrapper + ' step2'}>
              {['issuer', 'receiver', 'invoiceItems', 'payment', 'order', 'delivery', 'signatures'].map((group, index) => (
                !!Object.keys(invoiceData).length && !!Object.keys(filterData(invoiceData[group], ['payment', 'order', 'delivery'].includes(group)) || {})?.length &&
                <Accordion defaultExpanded={true} className={invoiceClasses.invoiceDataGroup} key={index}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <div className={formClasses.ItemHeadingWrapper}>
                      <Typography className={formClasses.ItemHeading}>{getGroupIcon(group)}<FormattedMessage
                        id={`Invoice.view.group.${group}.Title`}/></Typography>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className={formClasses.EntityInfoWrapper}>
                      {Object.keys(invoiceData[group] || {})?.map((column, columnIndex) => (
                        !!invoiceData[group][column] && column !== 'address' &&
                        <React.Fragment key={`${index}-${columnIndex}`}>
                          {column === 'invoiceItems' ?

                            <ListingTableProvider listArr={invoiceData[group][column] || []}>
                              <ListingTableConsumer>
                                {({
                                    handleChangeListingPage, handleChangeListingRowsPerPage, listingCount,
                                    listingData, listingPage, listingRowsPerPage
                                  }) => (
                                  <ItemsList
                                    handleChangeListingPage={handleChangeListingPage} noName={!isMs}
                                    handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                                    listingCount={listingCount} listingData={listingData}
                                    documentType={invoiceData?.general?.documentType}
                                    listingPage={listingPage} listingRowsPerPage={listingRowsPerPage}
                                    locale={locale} isForeign={invoiceData?.isForeign} sameCurrency
                                    isMultiForeign={invoiceData?.isMultiForeign}
                                    currentCurrency={{ key: invoiceData?.currency }} noActions/>
                                )}
                              </ListingTableConsumer>
                            </ListingTableProvider>
                            : (column === 'invoiceItemsSums' ?
                                <div className={formClasses.FormTotals + ' ' + invoiceClasses.itemsCalculations}>
                                  {!!Object.keys(invoiceData[group][column] || {})?.length && Object.keys(invoiceData[group][column] || {}).map((sum, sumIndex) => (
                                    !['invoiceItemsSumsEGP'].includes(sum) && !!invoiceData[group][column][sum] &&
                                    <React.Fragment key={`${index}-${columnIndex}-${sumIndex}`}>
                                      <div
                                        className={formClasses.FormItem + ' info ' + formClasses.FormRow + (sum === 'totalAmount' ? ' total' : '')}>
                                        <InputLabel><FormattedMessage
                                          id={`Fields.label.${group}.${sum}`}/> ({invoiceData?.currency})</InputLabel>
                                        <div className={'info-data'}>
                                          {!!invoiceData?.isMultiForeign ? <>
                                            <strong>{getColumnValue(sum, sum === 'taxTotals'? invoiceData[group][column]['invoiceItemsSumsEGP'][sum] : <FormattedNumber
                                              value={invoiceData[group][column]['invoiceItemsSumsEGP'][sum] || 0} minimumFractionDigits={2}/>)}</strong>
                                          </> : <>
                                            <strong>{getColumnValue(sum, sum === 'taxTotals'? invoiceData[group][column]['invoiceItemsSumsEGP'][sum] : <FormattedNumber
                                              value={invoiceData[group][column][sum] || 0} minimumFractionDigits={2}/>)}</strong> {!!invoiceData.isForeign &&
                                          <span>( {getColumnValue(sum, sum === 'taxTotals'? invoiceData[group][column]['invoiceItemsSumsEGP'][sum] : <FormattedNumber
                                            value={invoiceData[group][column]['invoiceItemsSumsEGP'][sum] || 0} minimumFractionDigits={2}/>)}&nbsp;<FormattedMessage id='EGP'/> )</span>}
                                          </>}

                                        </div>
                                      </div>
                                      {sum === 'taxTotals' && invoiceData[group][column][sum].map((tax, taxIndex) => {
                                        let type = [...taxTypes, ...nonTaxableTaxTypes].filter(item => item?.key?.toString() === tax?.taxType?.toString())
                                        type = !!type?.length ? <>{type[0][`name_view_${locale}`]}&nbsp;(<strong>{tax?.taxType}</strong>)</> : tax?.taxType || ''
                                        return (
                                          <div key={`${index}-${columnIndex}-${taxIndex}`}
                                               className={formClasses.FormItem + ' info tax'}>
                                            <InputLabel>{type} ({invoiceData?.currency})</InputLabel>
                                            <div className={'info-data'}>
                                              {!!invoiceData?.isMultiForeign ? <>
                                                <strong><FormattedNumber
                                                  value={invoiceData[group][column]['invoiceItemsSumsEGP'][sum][taxIndex]?.amount || 0} minimumFractionDigits={2}/></strong>
                                              </> : <>
                                                <strong><FormattedNumber value={tax?.amount} minimumFractionDigits={2}/></strong> {!!invoiceData.isForeign &&
                                              <span>( <FormattedNumber value={invoiceData[group][column]['invoiceItemsSumsEGP'][sum][taxIndex]?.amount} minimumFractionDigits={2}/>&nbsp;<FormattedMessage id='EGP'/> )</span>}
                                              </>}
                                            </div>
                                          </div>
                                        )
                                      })}
                                    </React.Fragment>
                                  ))}
                                </div>
                                :
                                <div key={`${index}-${columnIndex}`}
                                     className={formClasses.FormItem + ' info' + (['addressObj', 'signatures'].includes(column) ? ' row ' + formClasses.FormRow : '')}>
                                  {column === 'signatures' ?
                                    getColumnValue(column, invoiceData[group][column])
                                    : <>
                                      <InputLabel><FormattedMessage
                                        id={`Fields.label.${group}.${column}${group === 'receiver' && column === 'id' ? `.${invoiceData?.receiver?.type}` : ''}`}/>:</InputLabel>
                                      <div className={'info-data'}>
                                        <strong>{getColumnValue(column, invoiceData[group][column], !!(group === 'receiver' && column === 'type'))}</strong>
                                      </div>
                                    </>
                                  }
                                </div>
                            )
                          }
                        </React.Fragment>
                      ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Paper>
          </>
        )
      }}
    </InvoiceViewConsumer>
  )
}

export default SingleInvoicePageContent
